/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a status summary, an aggregated view on issues for a specific status or severity. These issues are attached to configurations of products or order entries
 * @export
 * @interface StatusSummary
 */
export interface StatusSummary {
    /**
     * Status or severity indicator, can be one of ERROR, WARNING, INFO or SUCCESS
     * @type {string}
     * @memberof StatusSummary
     */
    status?: string;
    /**
     * Number of issues per status
     * @type {number}
     * @memberof StatusSummary
     */
    numberOfIssues?: number;
}

/**
 * Check if a given object implements the StatusSummary interface.
 */
export function instanceOfStatusSummary(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatusSummaryFromJSON(json: any): StatusSummary {
    return StatusSummaryFromJSONTyped(json, false);
}

export function StatusSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'numberOfIssues': !exists(json, 'numberOfIssues') ? undefined : json['numberOfIssues'],
    };
}

export function StatusSummaryToJSON(value?: StatusSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'numberOfIssues': value.numberOfIssues,
    };
}

